/* sp-stats.js — sayaç + ilerleme çubuğu (IntersectionObserver, eşik .5, süre data-duration). Metin yok: sonek data-suffix ile Liquid'den gelir. */
(function () {
  function fills(root) { root.querySelectorAll('[data-sp-stat-fill]').forEach(function (f) { f.style.width = (parseFloat(f.dataset.width) || 0) + '%'; }); }
  function finish(root) {
    var suffix = root.dataset.suffix || '';
    root.querySelectorAll('[data-sp-stat-num]').forEach(function (n) { n.textContent = (parseInt(n.dataset.target, 10) || 0) + suffix; });
    fills(root);
  }
  function animate(root) {
    var suffix = root.dataset.suffix || '';
    var dur = parseInt(root.dataset.duration, 10) || 1500;
    fills(root);
    root.querySelectorAll('[data-sp-stat-num]').forEach(function (n) {
      var target = parseInt(n.dataset.target, 10) || 0, cur = 0;
      if (target <= 0) { n.textContent = '0' + suffix; return; }
      var stepMs = Math.max(4, dur / target);
      var timer = setInterval(function () {
        cur += 1;
        if (cur >= target) { cur = target; clearInterval(timer); }
        n.textContent = cur + suffix;
      }, stepMs);
    });
  }
  function init(root) {
    if (root.dataset.spInit) return; root.dataset.spInit = '1';
    var grid = root.querySelector('[data-sp-stats-grid]') || root;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (root.dataset.animate !== 'true' || reduce || !('IntersectionObserver' in window)) { finish(root); return; }
    var th = 0.5, h = grid.offsetHeight;
    if (h > 0) th = Math.min(0.5, (window.innerHeight * 0.5) / h);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); animate(root); } });
    }, { threshold: th });
    io.observe(grid);
  }
  function boot() { document.querySelectorAll('[data-sp-stats]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
